module.exports = __webpack_public_path__ + "static/img/77092G_R_01_20170922all_LC.37c42b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77092G_R_01_20170922all_LC.png
// module id = USYn
// module chunks = 0